<template>
    <main-layout class="min-h-dvh flex flex-col">
        <!-- En-tête avec dégradé -->
        <div class="bg-gradient-to-b from-secondary to-primary">
            <app-header icon="gear" class="text-white pt-4 px-4 pb-8">
                <h1 class="text-2xl flex items-center gap-3">
                    <span>Configuration</span>
                </h1>
            </app-header>
        </div>

        <!-- Contenu principal avec fond dégradé arrondi -->
        <main class="bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 overflow-y-auto shadow-xl pb-28">
            <div class="p-4 space-y-6">

                <!-- Section de bienvenue -->
                <section id="start-config" :class="{'hidden': activeSection !== 'start'}">
                    <div class="bg-white rounded-xl shadow-lg p-6 text-center">
                        <h2 class="text-2xl md:text-3xl font-bold text-primary mb-4">
                            Bonjour <strong>{{ user.last_name + ' ' + user.first_name }}</strong> !
                        </h2>
                        <p class="text-md md:text-lg text-gray-700 mb-6">
                            Bienvenue sur la page de configuration de votre <strong>application F.i360°</strong>.
                        </p>
                        <button
                            id="next-trigger"
                            @click.prevent="goToSection('add-signature')"
                            class="w-full bg-primary text-white font-semibold rounded-lg shadow-lg hover:bg-primary-hover transition-colors text-lg py-4 px-6 flex items-center justify-center gap-3">
                            <i class="inline-block h-6 w-6 mask mask-tools bg-white"></i>
                            <span>Configurer</span>
                            <i class="inline-block h-6 w-6 mask mask-arrow-right bg-white"></i>
                        </button>
                    </div>
                </section>

                <!-- Section signature -->
                <section id="add-signature" :class="{'hidden': activeSection !== 'add-signature'}">
                    <div class="bg-white rounded-xl shadow-lg p-6">
                        <div class="text-center mb-6">
                            <i class="inline-block h-10 w-10 mask mask-sign bg-secondary mb-4"></i>
                            <h3 class="text-xl font-bold text-primary mb-3 uppercase">Ma signature</h3>
                            <p class="text-md text-gray-700">
                                Afin de pouvoir signer numériquement vos rapports d'interventions, merci d'enregistrer votre signature manuscrite.
                            </p>
                        </div>
                        <button
                            id="signature-trigger"
                            @click.prevent="showModal = true"
                            class="w-full bg-primary text-white font-semibold rounded-lg shadow-lg hover:bg-primary-hover transition-colors text-md py-4 px-6 flex items-center justify-center gap-3">
                            <span><strong>Enregistrer</strong> ma signature</span>
                            <i class="inline-block h-6 w-6 mask mask-arrow-right bg-white"></i>
                        </button>
                    </div>

                    <signature-modal
                        v-show="showModal"
                        @close="showModal = false"
                        @signatureUpdated="saveSignature">
                    </signature-modal>
                </section>

                <!-- Section photo -->
                <section id="add-photo" :class="{'hidden': activeSection !== 'add-photo'}">
                    <div class="bg-white rounded-xl shadow-lg p-6">
                        <div class="text-center mb-6">
                            <i class="inline-block h-10 w-10 mask mask-photo bg-secondary mb-4"></i>
                            <h3 class="text-xl font-bold text-primary mb-3 uppercase">Ma photo de profil</h3>
                            <p class="text-md text-gray-700">
                                Afin de bénéficier d'une interface plus personnelle merci de bien vouloir ajouter une photo de profil.
                            </p>
                        </div>

                        <form method="post" id="photoprofil" enctype="multipart/form-data" class="hidden">
                            <input type="file" accept="image/*" name="change-photo-profil" ref="inputphoto"
                                   @change="savePhoto">
                        </form>

                        <button
                            id="photo-trigger"
                            @click.prevent="triggerPhoto"
                            class="w-full bg-primary text-white font-semibold rounded-lg shadow-lg hover:bg-primary-hover transition-colors text-md py-4 px-6 flex items-center justify-center gap-3 mb-4">
                            <span>Ajouter ma photo</span>
                            <i class="inline-block h-6 w-6 mask mask-arrow-right bg-white"></i>
                        </button>

                        <router-link
                            to="home"
                            id="ignore"
                            class="block text-center text-gray-600 hover:text-primary transition-colors py-2">
                            Pas maintenant
                        </router-link>
                    </div>
                </section>

            </div>
        </main>
    </main-layout>
</template>

<script>

    // LIBS
    import loadImage from 'blueimp-load-image'
    import localforage from 'localforage'
    // JS CLASS
    import Offline from '../../js/models/Offline'

    // COMPONENTS
    import SignatureModal from '../common/SignatureModal.vue'

    export default {

        data() {
            return {
                user: {},
                showModal: false,
                activeSection: 'start'
            }
        },

        methods: {

            goToSection(id) {
                this.activeSection = id;
            },

            triggerPhoto() {
                this.$refs.inputphoto.click()
            },

            async fetchUser() {
                this.user = JSON.parse(await localforage.getItem('profil'));
                return true
            },

            async saveSignature(data) {

                let usrData = JSON.parse(await localforage.getItem('profil'));
                usrData.signature64 = data;
                await localforage.setItem('profil', JSON.stringify(usrData));
                await Offline.saveAction({action: 'update', type: 'User', id: usrData.id});

                this.goToSection('add-photo')

            },

            async savePhoto(e) {

                loadImage(
                    e.target.files[0],
                    photo => {
                        let img = photo.toDataURL();

                        localforage
                            .getItem('profil')
                            .then(res => {

                                let usrData = JSON.parse(res);
                                usrData.photo64 = img;
                                return localforage.setItem('profil', JSON.stringify(usrData))

                            })
                            .then(() => this.$router.push('home'))
                            .catch()

                    },
                    {
                        maxWidth: 600,
                        maxHeight: 600,
                        orientation: true,
                        canvas: true
                    }
                )

            }

        },

        mounted() {

            this.fetchUser()

        },

        components: {
            SignatureModal
        }

    }

</script>



// WEBPACK FOOTER //
// Config.vue?7a56e738